import { css, Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { InputAlign } from "@skbkontur/react-ui";

import { theme as themeHelper } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";
import { HighlightingType } from "../../ExternalHighlighting";

export const highlighted = (theme: Theme) =>
    css({
        borderColor: theme.candy.valueControls.highlightedBorderColor,
        borderRadius: "1px",
        boxShadow: `0 0 0 1px ${theme.candy.valueControls.highlightedBorderColor}`,
        position: "relative",
        zIndex: 2,
    });

export const hideCursor = (theme: Theme) =>
    css({
        input: {
            color: "transparent",
            textShadow: `0 0 0 ${theme.candy.valueControls.disabledCursorTextShadowColor}`,
            ":focus": {
                outline: "none",
            },
        },
    });

export const GrayWrapper = styled.div(props => ({
    color: themeHelper(props).valueControls.placeholderColor,
}));

const resolveHighlighting = (theme: Theme, type: HighlightingType) => {
    const borderWarningStyle = "1px solid" + themeHelper(theme).semanticColors.warning.alternativeColor;
    const bgWarningColor = themeHelper(theme).semanticColors.warning.backgroundColor;
    const defaultBgColor = themeHelper(theme).keyPalette.panelBackgroundColor;

    const background = {
        "bg-warning": bgWarningColor,
        "border-warning": defaultBgColor,
        default: defaultBgColor,
    };
    const border = {
        "bg-warning": borderWarningStyle,
        "border-warning": borderWarningStyle,
        default: undefined,
    };

    return { background: background[type], border: border[type] };
};

export const ReadOnlyTextWrapper = styled.div<{
    width: string | number;
    noPadding?: boolean;
    externalFocused?: boolean;
    highlightingType?: HighlightingType;
    removeBackground?: boolean;
}>(props => {
    const padding = props.noPadding ? 0 : 2;
    // двойной паддинг сохраняет исходную высоту при переходе на border-box
    const minHeight = padding * 2 + themeHelper(props).typography.primary.lineHeight.getNumber();
    const bg = props.removeBackground ? undefined : themeHelper(props).keyPalette.panelBackgroundColor;
    return {
        boxSizing: "border-box",
        display: "inline-flex",
        width: props.width,
        background: props.highlightingType ? resolveHighlighting(props.theme, props.highlightingType).background : bg,
        border: props.highlightingType ? resolveHighlighting(props.theme, props.highlightingType).border : undefined,
        color: "black",
        borderRadius: "2px",
        padding: padding,
        minHeight: minHeight,
        verticalAlign: "text-bottom",
    };
});

export const ReadOnlyAlignInput = styled.div<{ align: InputAlign | undefined }>(props => ({
    display: "flex",
    width: "100%",
    margin: "0 2px 0 2px",
    justifyContent: alignConverter(props.align),
}));

export type FlexBoxAlign = "flex-end" | "flex-start" | "center" | "space-between" | "space-around";

const alignConverter = (align: InputAlign | undefined): FlexBoxAlign => {
    if (align === "right") {
        return "flex-end";
    }
    if (align === "left") {
        return "flex-start";
    }
    if (align === "center") {
        return "center";
    }
    return "flex-start";
};
